<template>
  <div
    v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.DELETE)"
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder spl-reactivate-parcel-modal"
    @click.self="closeModal">
    <div class="spl-modal">
      <div class="spl-modal__label">
        What is the reason for reactivating the parcel?
      </div>
      <form-label>Reason</form-label>
      <form-input
        v-model="message"
        :invalid="$v.message.$error"
        class="spl-reactivate-parcel-modal__message"
        @blur="$v.message.$touch()" />
      <span v-if="$v.message.$error && !$v.message.required" class="error">Reason is required</span>
      <span v-if="$v.message.$error && !$v.message.maxLength" class="error">Reason can not be longer than 1024 characters</span>

      <div class="spl-modal__close" @click="closeModal" />
      <div class="row">
        <div class="col6">
          <form-button
            :wide="true"
            :secondary="true"
            @onClick="closeModal">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button
            :wide="true"
            :disabled="$v.$invalid"
            class="spl-button spl-reactivate-parcel-modal__reactivate"
            @onClick="submitModal">
            Reactivate
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import webApi from '@/webApi'
import { ReactivateParcelsModel } from '@/webApi/DataModels'
import constants from '@/constants'
import Helpers from '@/helpers.vue'
import { map } from 'lodash'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [Helpers],
  props: ['parcels'],
  data () {
    return {
      isVisible: false,
      message: '',
      constants
    }
  },
  validations: {
    message: {
      required,
      maxLength: maxLength(1024)
    }
  },
  watch: {
    parcels: function (newValue) {
      if (newValue && newValue.length > 0) {
        this.isVisible = true
      } else {
        this.isVisible = false
      }
    }
  },
  mounted () {
  },
  methods: {
    submitModal () {
      var deleteParcelModel:ReactivateParcelsModel = { Parcel_IDs: map(this.parcels, 'Parcel_ID'), Message: this.message } as ReactivateParcelsModel
      webApi.parcel.reactivate_Parcel_List(deleteParcelModel)
        .then((result) => {
          this.isVisible = false
          this.message = ''
          this.$toast('Successfully reactivated', constants.defaultToastOptions())
          this.$emit('parcelReactivated')
        }).catch((error) => {
          window.bus.$emit('openErrorModal', 'Error uploading file: ' + error.data.ExceptionMessage)
        })
    },
    // Close the scan window
    closeModal () {
      this.isVisible = false
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';
    .spl-reactivate-parcel-modal {
      .error {
        margin-bottom: 20px;
        margin-top: -10px;
      }
    }

</style>
